import "./App.css";
import { HelmetProvider } from "react-helmet-async";
import HomePage from "./components/HomePage/HomePage";
import NavBar from "./components/NavBar/NavBar";
import BottomBar from "./components/BottomBar/BottomBar";
import { Routes, Route, Navigate } from "react-router-dom";
import PrivateRoute from "./components/auth/PrivateRoute";

import React, { useState, lazy, Suspense } from "react";

// Lazy load components that are not needed for initial page load
const Login = lazy(() => import("./components/Login/Login"));
const Signup = lazy(() => import("./components/Signup/Signup"));
const UploadTabu = lazy(() => import("./components/UploadTabu/UploadTabu"));
const Compare = lazy(() => import("./components/Compare/Compare"));
const FAQSection = lazy(() => import("./components/FAQ/FAQSection/FAQSection"));
const AccountLayout = lazy(() => import("./components/account/AccountLayout"));
const Dashboard = lazy(() => import("./components/account/Dashboard"));
const PropertyDashboard = lazy(() => import("./components/account/PropertyDashboard"));
const Profile = lazy(() => import("./components/account/Profile"));
const Settings = lazy(() => import("./components/account/Settings"));
const Documents = lazy(() => import("./components/account/Documents"));
const RefundPolicy = lazy(() => import("./components/BottomBar/RefundPolicy"));
const TermsOfUse = lazy(() => import("./components/BottomBar/TermsOfUse"));
const PrivacyPolicy = lazy(() => import("./components/BottomBar/PrivacyPolicy"));
const Plans = lazy(() => import("./components/PricingPlans/Plans"));
const FilePreview = lazy(() => import("./components/FilePreview/FilePreview"));
const PaymentConfirmation = lazy(() => import("./components/PaymentConfirmation/PaymentConfirmation"));

// Loading fallback component - Simple fast spinner
const LoadingFallback = () => (
  <div className="loading-fallback">
    <div className="loading-spinner"></div>
  </div>
);

function App() {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false); 
  const [isSignupModalOpen, setIsSignupModalOpen] = useState(false); 

  const handleOpenLoginModal = () => {
    setIsLoginModalOpen(true);
    setIsSignupModalOpen(false); // סגור את מודל ההרשמה אם פתוח
  };

  const handleCloseLoginModal = () => {
    setIsLoginModalOpen(false);
  };

  const handleOpenSignupModal = () => {
    setIsSignupModalOpen(true);
    setIsLoginModalOpen(false); // סגור את מודל ההתחברות אם פתוח
  };

  const handleCloseSignupModal = () => {
    setIsSignupModalOpen(false);
  };

  return (
    <HelmetProvider>
      <div dir="rtl">
        <NavBar
          onLoginClick={handleOpenLoginModal}
          onSignupClick={handleOpenSignupModal}
        />
      <Suspense fallback={<LoadingFallback />}>
      <Routes>
        <Route exact path="/" element={<HomePage />} />
{/* <Route path="/upload-tabu" element={<UploadTabu />} /> */}
        {/* <Route path="/PricingPlans" element={<PricingPlans />} /> */}
        <Route path="/plans" element={<Plans />} />
        <Route path="/preview" element={<FilePreview />} />
        <Route path="/confirmation" element={<PaymentConfirmation />} />
        <Route path="/faq" element={<FAQSection />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/terms" element={<TermsOfUse />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route
          path="/upload-tabu"
          element={
            <PrivateRoute>
              <UploadTabu />
            </PrivateRoute>
          }
        />
        <Route
          path="/compare"
          element={
            <PrivateRoute>
              <Compare />
            </PrivateRoute>
          }
        />
        <Route
          path="/account"
          element={
            <PrivateRoute>
              <AccountLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="properties" element={<PropertyDashboard />} />
          <Route path="documents" element={<Documents />} />
          <Route path="profile" element={<Profile />} />
          {/* <Route path="billing" element={<Billing />} /> */}
          <Route path="settings" element={<Settings />} />
        </Route>
      </Routes>
      </Suspense>
      <BottomBar />

      {isLoginModalOpen && (
        <Login
          onClose={handleCloseLoginModal}
          onSwitchToSignup={handleOpenSignupModal}
        />
      )}
      {isSignupModalOpen && (
        <Signup
          onClose={handleCloseSignupModal}
          onSwitchToLogin={handleOpenLoginModal}
        />
      )}
      </div>
    </HelmetProvider>
  );
}

export default App;
